"use client";
import CommonTitle from "@/components/common/CommonTitle";

const SalesContact = () => {
  return (
    <section className="bg-gradient-to-t from-[#F4F4FD] to-[#FFFFFF] py-[40px] xl:py-[60px]">
      <div className="container text-center">
        <CommonTitle
          as="h2"
          color="#202020"
          fontWeightClass="font-semibold"
          fontSizeClass="text-[24px] xl:text-[32px]"
        >
          Questions? We&apos;ve Got{" "}
          <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">Answers</span>
        </CommonTitle>
        <p className="mx-auto mt-4 max-w-[600px] text-[18px] text-[#202020]">
          Reach out to our team to see how your organization can benefit from
          Kroolo
        </p>
        <div className="mt-8 inline-flex items-center gap-4 rounded-[8px] bg-white px-6 py-4 shadow-md">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-r from-[#781E8F] to-[#422CBB] text-white">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                stroke="white"
                strokeWidth="2"
              />
              <path d="M22 6L12 13L2 6" stroke="white" strokeWidth="2" />
            </svg>
          </div>
          <a
            href="mailto:sales@kroolo.com"
            className="text-[18px] font-semibold bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent hover:underline"
          >
            sales@kroolo.com
          </a>
        </div>
      </div>
    </section>
  );
};

export default SalesContact;
